/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Upload_LabelInputs */

const en_orders_upload_label = /** @type {(inputs: Orders_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Label`)
};

const es_orders_upload_label = /** @type {(inputs: Orders_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir etiqueta`)
};

/**
* | output |
* | --- |
* | "Upload Label" |
*
* @param {Orders_Upload_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_upload_label = /** @type {((inputs?: Orders_Upload_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Upload_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_upload_label(inputs)
	return es_orders_upload_label(inputs)
});